module.exports = __webpack_public_path__ + "img/aParty_121223_C.23c74f33.jpg";